import cx from 'classnames';

import { LABELS } from '../labels';

import styles from '../styles.module.css';

const RunJobRoute = ({ runName, jobCode, routeText }) => (
	<>
		<div className={styles.value}>
			<span className={styles.runJob}>
				{LABELS.run} {runName}
			</span>
			<span className={cx(styles.runJob, styles.runJobWithGap)}>
				{LABELS.job} {jobCode}
			</span>
		</div>
		<div className={styles.value}>{routeText}</div>
	</>
);

export default RunJobRoute;
